/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as TestLoginRouteRouteImport } from './routes/test-login/route'
import { Route as StudyGroupRouteRouteImport } from './routes/study-group/route'
import { Route as ProtoUiRouteRouteImport } from './routes/proto-ui/route'
import { Route as ProtoForUserRouteRouteImport } from './routes/proto-for-user/route'
import { Route as ProtoForAdminRouteRouteImport } from './routes/proto-for-admin/route'
import { Route as LogoutRouteRouteImport } from './routes/logout/route'
import { Route as FavoritesRouteRouteImport } from './routes/favorites/route'
import { Route as ChatRoomRouteRouteImport } from './routes/chat-room/route'
import { Route as CallbackRouteRouteImport } from './routes/callback/route'
import { Route as CalendarRouteRouteImport } from './routes/calendar/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventSearchIndexRouteImport } from './routes/event-search/index'
import { Route as ChatRoomIndexRouteImport } from './routes/chat-room/index'
import { Route as AllStudyGroupsIndexRouteImport } from './routes/all-study-groups/index'
import { Route as SettingsPeriodicNotificationRouteImport } from './routes/settings/periodic-notification'
import { Route as SettingsInstantNotificationRouteImport } from './routes/settings/instant-notification'
import { Route as UserProfileUserIdRouteRouteImport } from './routes/user-profile/$user-id/route'
import { Route as StudyGroupStudyGroupIdRouteRouteImport } from './routes/study-group/$study-group-id/route'
import { Route as PublicEventEventCodeRouteRouteImport } from './routes/public-event/$event-code/route'
import { Route as NotificationEntryRouteRouteImport } from './routes/notification/entry/route'
import { Route as EventSearchEventIdRouteRouteImport } from './routes/event-search/$event-id/route'
import { Route as ChatRoomChatRoomIdRouteRouteImport } from './routes/chat-room/$chat-room-id/route'
import { Route as AllStudyGroupsStudyGroupIdRouteRouteImport } from './routes/all-study-groups/$study-group-id/route'
import { Route as StudyGroupStudyGroupIdIndexRouteImport } from './routes/study-group/$study-group-id/index'
import { Route as StudyGroupStudyGroupIdStreamRouteRouteImport } from './routes/study-group/$study-group-id/stream/route'
import { Route as StudyGroupStudyGroupIdLinkListRouteRouteImport } from './routes/study-group/$study-group-id/link-list/route'
import { Route as StudyGroupStudyGroupIdInfoRouteRouteImport } from './routes/study-group/$study-group-id/info/route'
import { Route as StudyGroupStudyGroupIdHomeRouteRouteImport } from './routes/study-group/$study-group-id/home/route'
import { Route as StudyGroupStudyGroupIdFilesRouteRouteImport } from './routes/study-group/$study-group-id/files/route'
import { Route as StudyGroupStudyGroupIdEventsRouteRouteImport } from './routes/study-group/$study-group-id/events/route'
import { Route as EventSearchCodeEventCodeRouteRouteImport } from './routes/event-search/code/$event-code/route'
import { Route as StudyGroupStudyGroupIdStreamIndexRouteImport } from './routes/study-group/$study-group-id/stream/index'
import { Route as StudyGroupStudyGroupIdPostPostIdRouteRouteImport } from './routes/study-group/$study-group-id/post/$post-id/route'
import { Route as StudyGroupStudyGroupIdHomeTabRouteRouteImport } from './routes/study-group/$study-group-id/home/$tab/route'
import { Route as StudyGroupStudyGroupIdChannelChannelIdRouteRouteImport } from './routes/study-group/$study-group-id/channel/$channel-id/route'
import { Route as StudyGroupStudyGroupIdStreamChannelChannelIdRouteRouteImport } from './routes/study-group/$study-group-id/stream/channel/$channel-id/route'
import { Route as StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRouteImport } from './routes/study-group/$study-group-id/link-list/category/$category-id/route'
import { Route as StudyGroupStudyGroupIdFilesFolderFolderIdRouteRouteImport } from './routes/study-group/$study-group-id/files/folder/$folder-id/route'
import { Route as StudyGroupStudyGroupIdChannelChannelIdTabRouteRouteImport } from './routes/study-group/$study-group-id/channel/$channel-id/$tab/route'

const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const TestLoginRouteRoute = TestLoginRouteRouteImport.update({
  id: '/test-login',
  path: '/test-login',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyGroupRouteRoute = StudyGroupRouteRouteImport.update({
  id: '/study-group',
  path: '/study-group',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtoUiRouteRoute = ProtoUiRouteRouteImport.update({
  id: '/proto-ui',
  path: '/proto-ui',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtoForUserRouteRoute = ProtoForUserRouteRouteImport.update({
  id: '/proto-for-user',
  path: '/proto-for-user',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtoForAdminRouteRoute = ProtoForAdminRouteRouteImport.update({
  id: '/proto-for-admin',
  path: '/proto-for-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRouteRoute = LogoutRouteRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRouteRoute = FavoritesRouteRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoomRouteRoute = ChatRoomRouteRouteImport.update({
  id: '/chat-room',
  path: '/chat-room',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRouteRoute = CallbackRouteRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRouteRoute = CalendarRouteRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventSearchIndexRoute = EventSearchIndexRouteImport.update({
  id: '/event-search/',
  path: '/event-search/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoomIndexRoute = ChatRoomIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoomRouteRoute,
} as any)
const AllStudyGroupsIndexRoute = AllStudyGroupsIndexRouteImport.update({
  id: '/all-study-groups/',
  path: '/all-study-groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPeriodicNotificationRoute =
  SettingsPeriodicNotificationRouteImport.update({
    id: '/settings/periodic-notification',
    path: '/settings/periodic-notification',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsInstantNotificationRoute =
  SettingsInstantNotificationRouteImport.update({
    id: '/settings/instant-notification',
    path: '/settings/instant-notification',
    getParentRoute: () => rootRouteImport,
  } as any)
const UserProfileUserIdRouteRoute = UserProfileUserIdRouteRouteImport.update({
  id: '/user-profile/$user-id',
  path: '/user-profile/$user-id',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyGroupStudyGroupIdRouteRoute =
  StudyGroupStudyGroupIdRouteRouteImport.update({
    id: '/$study-group-id',
    path: '/$study-group-id',
    getParentRoute: () => StudyGroupRouteRoute,
  } as any)
const PublicEventEventCodeRouteRoute =
  PublicEventEventCodeRouteRouteImport.update({
    id: '/public-event/$event-code',
    path: '/public-event/$event-code',
    getParentRoute: () => rootRouteImport,
  } as any)
const NotificationEntryRouteRoute = NotificationEntryRouteRouteImport.update({
  id: '/notification/entry',
  path: '/notification/entry',
  getParentRoute: () => rootRouteImport,
} as any)
const EventSearchEventIdRouteRoute = EventSearchEventIdRouteRouteImport.update({
  id: '/event-search/$event-id',
  path: '/event-search/$event-id',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoomChatRoomIdRouteRoute = ChatRoomChatRoomIdRouteRouteImport.update({
  id: '/$chat-room-id',
  path: '/$chat-room-id',
  getParentRoute: () => ChatRoomRouteRoute,
} as any)
const AllStudyGroupsStudyGroupIdRouteRoute =
  AllStudyGroupsStudyGroupIdRouteRouteImport.update({
    id: '/all-study-groups/$study-group-id',
    path: '/all-study-groups/$study-group-id',
    getParentRoute: () => rootRouteImport,
  } as any)
const StudyGroupStudyGroupIdIndexRoute =
  StudyGroupStudyGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdStreamRouteRoute =
  StudyGroupStudyGroupIdStreamRouteRouteImport.update({
    id: '/stream',
    path: '/stream',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdLinkListRouteRoute =
  StudyGroupStudyGroupIdLinkListRouteRouteImport.update({
    id: '/link-list',
    path: '/link-list',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdInfoRouteRoute =
  StudyGroupStudyGroupIdInfoRouteRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdHomeRouteRoute =
  StudyGroupStudyGroupIdHomeRouteRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdFilesRouteRoute =
  StudyGroupStudyGroupIdFilesRouteRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdEventsRouteRoute =
  StudyGroupStudyGroupIdEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const EventSearchCodeEventCodeRouteRoute =
  EventSearchCodeEventCodeRouteRouteImport.update({
    id: '/event-search/code/$event-code',
    path: '/event-search/code/$event-code',
    getParentRoute: () => rootRouteImport,
  } as any)
const StudyGroupStudyGroupIdStreamIndexRoute =
  StudyGroupStudyGroupIdStreamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudyGroupStudyGroupIdStreamRouteRoute,
  } as any)
const StudyGroupStudyGroupIdPostPostIdRouteRoute =
  StudyGroupStudyGroupIdPostPostIdRouteRouteImport.update({
    id: '/post/$post-id',
    path: '/post/$post-id',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdHomeTabRouteRoute =
  StudyGroupStudyGroupIdHomeTabRouteRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => StudyGroupStudyGroupIdHomeRouteRoute,
  } as any)
const StudyGroupStudyGroupIdChannelChannelIdRouteRoute =
  StudyGroupStudyGroupIdChannelChannelIdRouteRouteImport.update({
    id: '/channel/$channel-id',
    path: '/channel/$channel-id',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)
const StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute =
  StudyGroupStudyGroupIdStreamChannelChannelIdRouteRouteImport.update({
    id: '/channel/$channel-id',
    path: '/channel/$channel-id',
    getParentRoute: () => StudyGroupStudyGroupIdStreamRouteRoute,
  } as any)
const StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute =
  StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRouteImport.update({
    id: '/category/$category-id',
    path: '/category/$category-id',
    getParentRoute: () => StudyGroupStudyGroupIdLinkListRouteRoute,
  } as any)
const StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute =
  StudyGroupStudyGroupIdFilesFolderFolderIdRouteRouteImport.update({
    id: '/folder/$folder-id',
    path: '/folder/$folder-id',
    getParentRoute: () => StudyGroupStudyGroupIdFilesRouteRoute,
  } as any)
const StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute =
  StudyGroupStudyGroupIdChannelChannelIdTabRouteRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => StudyGroupStudyGroupIdChannelChannelIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/chat-room': typeof ChatRoomRouteRouteWithChildren
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/proto-for-admin': typeof ProtoForAdminRouteRoute
  '/proto-for-user': typeof ProtoForUserRouteRoute
  '/proto-ui': typeof ProtoUiRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdRouteRouteWithChildren
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups/': typeof AllStudyGroupsIndexRoute
  '/chat-room/': typeof ChatRoomIndexRoute
  '/event-search/': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRouteWithChildren
  '/study-group/$study-group-id/home': typeof StudyGroupStudyGroupIdHomeRouteRouteWithChildren
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRouteWithChildren
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamRouteRouteWithChildren
  '/study-group/$study-group-id/': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/channel/$channel-id': typeof StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren
  '/study-group/$study-group-id/home/$tab': typeof StudyGroupStudyGroupIdHomeTabRouteRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
  '/study-group/$study-group-id/stream/': typeof StudyGroupStudyGroupIdStreamIndexRoute
  '/study-group/$study-group-id/channel/$channel-id/$tab': typeof StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute
  '/study-group/$study-group-id/files/folder/$folder-id': typeof StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute
  '/study-group/$study-group-id/link-list/category/$category-id': typeof StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute
  '/study-group/$study-group-id/stream/channel/$channel-id': typeof StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/proto-for-admin': typeof ProtoForAdminRouteRoute
  '/proto-for-user': typeof ProtoForUserRouteRoute
  '/proto-ui': typeof ProtoUiRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups': typeof AllStudyGroupsIndexRoute
  '/chat-room': typeof ChatRoomIndexRoute
  '/event-search': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRouteWithChildren
  '/study-group/$study-group-id/home': typeof StudyGroupStudyGroupIdHomeRouteRouteWithChildren
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRouteWithChildren
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/channel/$channel-id': typeof StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren
  '/study-group/$study-group-id/home/$tab': typeof StudyGroupStudyGroupIdHomeTabRouteRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamIndexRoute
  '/study-group/$study-group-id/channel/$channel-id/$tab': typeof StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute
  '/study-group/$study-group-id/files/folder/$folder-id': typeof StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute
  '/study-group/$study-group-id/link-list/category/$category-id': typeof StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute
  '/study-group/$study-group-id/stream/channel/$channel-id': typeof StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/chat-room': typeof ChatRoomRouteRouteWithChildren
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/proto-for-admin': typeof ProtoForAdminRouteRoute
  '/proto-for-user': typeof ProtoForUserRouteRoute
  '/proto-ui': typeof ProtoUiRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdRouteRouteWithChildren
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups/': typeof AllStudyGroupsIndexRoute
  '/chat-room/': typeof ChatRoomIndexRoute
  '/event-search/': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRouteWithChildren
  '/study-group/$study-group-id/home': typeof StudyGroupStudyGroupIdHomeRouteRouteWithChildren
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRouteWithChildren
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamRouteRouteWithChildren
  '/study-group/$study-group-id/': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/channel/$channel-id': typeof StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren
  '/study-group/$study-group-id/home/$tab': typeof StudyGroupStudyGroupIdHomeTabRouteRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
  '/study-group/$study-group-id/stream/': typeof StudyGroupStudyGroupIdStreamIndexRoute
  '/study-group/$study-group-id/channel/$channel-id/$tab': typeof StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute
  '/study-group/$study-group-id/files/folder/$folder-id': typeof StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute
  '/study-group/$study-group-id/link-list/category/$category-id': typeof StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute
  '/study-group/$study-group-id/stream/channel/$channel-id': typeof StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/callback'
    | '/chat-room'
    | '/favorites'
    | '/logout'
    | '/proto-for-admin'
    | '/proto-for-user'
    | '/proto-ui'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/study-group/$study-group-id'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups/'
    | '/chat-room/'
    | '/event-search/'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/home'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id/'
    | '/study-group/$study-group-id/channel/$channel-id'
    | '/study-group/$study-group-id/home/$tab'
    | '/study-group/$study-group-id/post/$post-id'
    | '/study-group/$study-group-id/stream/'
    | '/study-group/$study-group-id/channel/$channel-id/$tab'
    | '/study-group/$study-group-id/files/folder/$folder-id'
    | '/study-group/$study-group-id/link-list/category/$category-id'
    | '/study-group/$study-group-id/stream/channel/$channel-id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/callback'
    | '/favorites'
    | '/logout'
    | '/proto-for-admin'
    | '/proto-for-user'
    | '/proto-ui'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups'
    | '/chat-room'
    | '/event-search'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/home'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id'
    | '/study-group/$study-group-id/channel/$channel-id'
    | '/study-group/$study-group-id/home/$tab'
    | '/study-group/$study-group-id/post/$post-id'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id/channel/$channel-id/$tab'
    | '/study-group/$study-group-id/files/folder/$folder-id'
    | '/study-group/$study-group-id/link-list/category/$category-id'
    | '/study-group/$study-group-id/stream/channel/$channel-id'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/callback'
    | '/chat-room'
    | '/favorites'
    | '/logout'
    | '/proto-for-admin'
    | '/proto-for-user'
    | '/proto-ui'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/study-group/$study-group-id'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups/'
    | '/chat-room/'
    | '/event-search/'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/home'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id/'
    | '/study-group/$study-group-id/channel/$channel-id'
    | '/study-group/$study-group-id/home/$tab'
    | '/study-group/$study-group-id/post/$post-id'
    | '/study-group/$study-group-id/stream/'
    | '/study-group/$study-group-id/channel/$channel-id/$tab'
    | '/study-group/$study-group-id/files/folder/$folder-id'
    | '/study-group/$study-group-id/link-list/category/$category-id'
    | '/study-group/$study-group-id/stream/channel/$channel-id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRouteRoute: typeof CalendarRouteRoute
  CallbackRouteRoute: typeof CallbackRouteRoute
  ChatRoomRouteRoute: typeof ChatRoomRouteRouteWithChildren
  FavoritesRouteRoute: typeof FavoritesRouteRoute
  LogoutRouteRoute: typeof LogoutRouteRoute
  ProtoForAdminRouteRoute: typeof ProtoForAdminRouteRoute
  ProtoForUserRouteRoute: typeof ProtoForUserRouteRoute
  ProtoUiRouteRoute: typeof ProtoUiRouteRoute
  StudyGroupRouteRoute: typeof StudyGroupRouteRouteWithChildren
  TestLoginRouteRoute: typeof TestLoginRouteRoute
  NotFoundRoute: typeof NotFoundRoute
  AllStudyGroupsStudyGroupIdRouteRoute: typeof AllStudyGroupsStudyGroupIdRouteRoute
  EventSearchEventIdRouteRoute: typeof EventSearchEventIdRouteRoute
  NotificationEntryRouteRoute: typeof NotificationEntryRouteRoute
  PublicEventEventCodeRouteRoute: typeof PublicEventEventCodeRouteRoute
  UserProfileUserIdRouteRoute: typeof UserProfileUserIdRouteRoute
  SettingsInstantNotificationRoute: typeof SettingsInstantNotificationRoute
  SettingsPeriodicNotificationRoute: typeof SettingsPeriodicNotificationRoute
  AllStudyGroupsIndexRoute: typeof AllStudyGroupsIndexRoute
  EventSearchIndexRoute: typeof EventSearchIndexRoute
  EventSearchCodeEventCodeRouteRoute: typeof EventSearchCodeEventCodeRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-login': {
      id: '/test-login'
      path: '/test-login'
      fullPath: '/test-login'
      preLoaderRoute: typeof TestLoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-group': {
      id: '/study-group'
      path: '/study-group'
      fullPath: '/study-group'
      preLoaderRoute: typeof StudyGroupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proto-ui': {
      id: '/proto-ui'
      path: '/proto-ui'
      fullPath: '/proto-ui'
      preLoaderRoute: typeof ProtoUiRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proto-for-user': {
      id: '/proto-for-user'
      path: '/proto-for-user'
      fullPath: '/proto-for-user'
      preLoaderRoute: typeof ProtoForUserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proto-for-admin': {
      id: '/proto-for-admin'
      path: '/proto-for-admin'
      fullPath: '/proto-for-admin'
      preLoaderRoute: typeof ProtoForAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-room': {
      id: '/chat-room'
      path: '/chat-room'
      fullPath: '/chat-room'
      preLoaderRoute: typeof ChatRoomRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event-search/': {
      id: '/event-search/'
      path: '/event-search'
      fullPath: '/event-search/'
      preLoaderRoute: typeof EventSearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-room/': {
      id: '/chat-room/'
      path: '/'
      fullPath: '/chat-room/'
      preLoaderRoute: typeof ChatRoomIndexRouteImport
      parentRoute: typeof ChatRoomRouteRoute
    }
    '/all-study-groups/': {
      id: '/all-study-groups/'
      path: '/all-study-groups'
      fullPath: '/all-study-groups/'
      preLoaderRoute: typeof AllStudyGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/periodic-notification': {
      id: '/settings/periodic-notification'
      path: '/settings/periodic-notification'
      fullPath: '/settings/periodic-notification'
      preLoaderRoute: typeof SettingsPeriodicNotificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/instant-notification': {
      id: '/settings/instant-notification'
      path: '/settings/instant-notification'
      fullPath: '/settings/instant-notification'
      preLoaderRoute: typeof SettingsInstantNotificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-profile/$user-id': {
      id: '/user-profile/$user-id'
      path: '/user-profile/$user-id'
      fullPath: '/user-profile/$user-id'
      preLoaderRoute: typeof UserProfileUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-group/$study-group-id': {
      id: '/study-group/$study-group-id'
      path: '/$study-group-id'
      fullPath: '/study-group/$study-group-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdRouteRouteImport
      parentRoute: typeof StudyGroupRouteRoute
    }
    '/public-event/$event-code': {
      id: '/public-event/$event-code'
      path: '/public-event/$event-code'
      fullPath: '/public-event/$event-code'
      preLoaderRoute: typeof PublicEventEventCodeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notification/entry': {
      id: '/notification/entry'
      path: '/notification/entry'
      fullPath: '/notification/entry'
      preLoaderRoute: typeof NotificationEntryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event-search/$event-id': {
      id: '/event-search/$event-id'
      path: '/event-search/$event-id'
      fullPath: '/event-search/$event-id'
      preLoaderRoute: typeof EventSearchEventIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-room/$chat-room-id': {
      id: '/chat-room/$chat-room-id'
      path: '/$chat-room-id'
      fullPath: '/chat-room/$chat-room-id'
      preLoaderRoute: typeof ChatRoomChatRoomIdRouteRouteImport
      parentRoute: typeof ChatRoomRouteRoute
    }
    '/all-study-groups/$study-group-id': {
      id: '/all-study-groups/$study-group-id'
      path: '/all-study-groups/$study-group-id'
      fullPath: '/all-study-groups/$study-group-id'
      preLoaderRoute: typeof AllStudyGroupsStudyGroupIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-group/$study-group-id/': {
      id: '/study-group/$study-group-id/'
      path: '/'
      fullPath: '/study-group/$study-group-id/'
      preLoaderRoute: typeof StudyGroupStudyGroupIdIndexRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/stream': {
      id: '/study-group/$study-group-id/stream'
      path: '/stream'
      fullPath: '/study-group/$study-group-id/stream'
      preLoaderRoute: typeof StudyGroupStudyGroupIdStreamRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/link-list': {
      id: '/study-group/$study-group-id/link-list'
      path: '/link-list'
      fullPath: '/study-group/$study-group-id/link-list'
      preLoaderRoute: typeof StudyGroupStudyGroupIdLinkListRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/info': {
      id: '/study-group/$study-group-id/info'
      path: '/info'
      fullPath: '/study-group/$study-group-id/info'
      preLoaderRoute: typeof StudyGroupStudyGroupIdInfoRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/home': {
      id: '/study-group/$study-group-id/home'
      path: '/home'
      fullPath: '/study-group/$study-group-id/home'
      preLoaderRoute: typeof StudyGroupStudyGroupIdHomeRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/files': {
      id: '/study-group/$study-group-id/files'
      path: '/files'
      fullPath: '/study-group/$study-group-id/files'
      preLoaderRoute: typeof StudyGroupStudyGroupIdFilesRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/events': {
      id: '/study-group/$study-group-id/events'
      path: '/events'
      fullPath: '/study-group/$study-group-id/events'
      preLoaderRoute: typeof StudyGroupStudyGroupIdEventsRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/event-search/code/$event-code': {
      id: '/event-search/code/$event-code'
      path: '/event-search/code/$event-code'
      fullPath: '/event-search/code/$event-code'
      preLoaderRoute: typeof EventSearchCodeEventCodeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-group/$study-group-id/stream/': {
      id: '/study-group/$study-group-id/stream/'
      path: '/'
      fullPath: '/study-group/$study-group-id/stream/'
      preLoaderRoute: typeof StudyGroupStudyGroupIdStreamIndexRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdStreamRouteRoute
    }
    '/study-group/$study-group-id/post/$post-id': {
      id: '/study-group/$study-group-id/post/$post-id'
      path: '/post/$post-id'
      fullPath: '/study-group/$study-group-id/post/$post-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdPostPostIdRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/home/$tab': {
      id: '/study-group/$study-group-id/home/$tab'
      path: '/$tab'
      fullPath: '/study-group/$study-group-id/home/$tab'
      preLoaderRoute: typeof StudyGroupStudyGroupIdHomeTabRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdHomeRouteRoute
    }
    '/study-group/$study-group-id/channel/$channel-id': {
      id: '/study-group/$study-group-id/channel/$channel-id'
      path: '/channel/$channel-id'
      fullPath: '/study-group/$study-group-id/channel/$channel-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdChannelChannelIdRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteRoute
    }
    '/study-group/$study-group-id/stream/channel/$channel-id': {
      id: '/study-group/$study-group-id/stream/channel/$channel-id'
      path: '/channel/$channel-id'
      fullPath: '/study-group/$study-group-id/stream/channel/$channel-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdStreamChannelChannelIdRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdStreamRouteRoute
    }
    '/study-group/$study-group-id/link-list/category/$category-id': {
      id: '/study-group/$study-group-id/link-list/category/$category-id'
      path: '/category/$category-id'
      fullPath: '/study-group/$study-group-id/link-list/category/$category-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdLinkListRouteRoute
    }
    '/study-group/$study-group-id/files/folder/$folder-id': {
      id: '/study-group/$study-group-id/files/folder/$folder-id'
      path: '/folder/$folder-id'
      fullPath: '/study-group/$study-group-id/files/folder/$folder-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdFilesFolderFolderIdRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdFilesRouteRoute
    }
    '/study-group/$study-group-id/channel/$channel-id/$tab': {
      id: '/study-group/$study-group-id/channel/$channel-id/$tab'
      path: '/$tab'
      fullPath: '/study-group/$study-group-id/channel/$channel-id/$tab'
      preLoaderRoute: typeof StudyGroupStudyGroupIdChannelChannelIdTabRouteRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdChannelChannelIdRouteRoute
    }
  }
}

interface ChatRoomRouteRouteChildren {
  ChatRoomChatRoomIdRouteRoute: typeof ChatRoomChatRoomIdRouteRoute
  ChatRoomIndexRoute: typeof ChatRoomIndexRoute
}

const ChatRoomRouteRouteChildren: ChatRoomRouteRouteChildren = {
  ChatRoomChatRoomIdRouteRoute: ChatRoomChatRoomIdRouteRoute,
  ChatRoomIndexRoute: ChatRoomIndexRoute,
}

const ChatRoomRouteRouteWithChildren = ChatRoomRouteRoute._addFileChildren(
  ChatRoomRouteRouteChildren,
)

interface StudyGroupStudyGroupIdFilesRouteRouteChildren {
  StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute: typeof StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute
}

const StudyGroupStudyGroupIdFilesRouteRouteChildren: StudyGroupStudyGroupIdFilesRouteRouteChildren =
  {
    StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute:
      StudyGroupStudyGroupIdFilesFolderFolderIdRouteRoute,
  }

const StudyGroupStudyGroupIdFilesRouteRouteWithChildren =
  StudyGroupStudyGroupIdFilesRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdFilesRouteRouteChildren,
  )

interface StudyGroupStudyGroupIdHomeRouteRouteChildren {
  StudyGroupStudyGroupIdHomeTabRouteRoute: typeof StudyGroupStudyGroupIdHomeTabRouteRoute
}

const StudyGroupStudyGroupIdHomeRouteRouteChildren: StudyGroupStudyGroupIdHomeRouteRouteChildren =
  {
    StudyGroupStudyGroupIdHomeTabRouteRoute:
      StudyGroupStudyGroupIdHomeTabRouteRoute,
  }

const StudyGroupStudyGroupIdHomeRouteRouteWithChildren =
  StudyGroupStudyGroupIdHomeRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdHomeRouteRouteChildren,
  )

interface StudyGroupStudyGroupIdLinkListRouteRouteChildren {
  StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute: typeof StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute
}

const StudyGroupStudyGroupIdLinkListRouteRouteChildren: StudyGroupStudyGroupIdLinkListRouteRouteChildren =
  {
    StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute:
      StudyGroupStudyGroupIdLinkListCategoryCategoryIdRouteRoute,
  }

const StudyGroupStudyGroupIdLinkListRouteRouteWithChildren =
  StudyGroupStudyGroupIdLinkListRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdLinkListRouteRouteChildren,
  )

interface StudyGroupStudyGroupIdStreamRouteRouteChildren {
  StudyGroupStudyGroupIdStreamIndexRoute: typeof StudyGroupStudyGroupIdStreamIndexRoute
  StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute: typeof StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute
}

const StudyGroupStudyGroupIdStreamRouteRouteChildren: StudyGroupStudyGroupIdStreamRouteRouteChildren =
  {
    StudyGroupStudyGroupIdStreamIndexRoute:
      StudyGroupStudyGroupIdStreamIndexRoute,
    StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute:
      StudyGroupStudyGroupIdStreamChannelChannelIdRouteRoute,
  }

const StudyGroupStudyGroupIdStreamRouteRouteWithChildren =
  StudyGroupStudyGroupIdStreamRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdStreamRouteRouteChildren,
  )

interface StudyGroupStudyGroupIdChannelChannelIdRouteRouteChildren {
  StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute: typeof StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute
}

const StudyGroupStudyGroupIdChannelChannelIdRouteRouteChildren: StudyGroupStudyGroupIdChannelChannelIdRouteRouteChildren =
  {
    StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute:
      StudyGroupStudyGroupIdChannelChannelIdTabRouteRoute,
  }

const StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren =
  StudyGroupStudyGroupIdChannelChannelIdRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdChannelChannelIdRouteRouteChildren,
  )

interface StudyGroupStudyGroupIdRouteRouteChildren {
  StudyGroupStudyGroupIdEventsRouteRoute: typeof StudyGroupStudyGroupIdEventsRouteRoute
  StudyGroupStudyGroupIdFilesRouteRoute: typeof StudyGroupStudyGroupIdFilesRouteRouteWithChildren
  StudyGroupStudyGroupIdHomeRouteRoute: typeof StudyGroupStudyGroupIdHomeRouteRouteWithChildren
  StudyGroupStudyGroupIdInfoRouteRoute: typeof StudyGroupStudyGroupIdInfoRouteRoute
  StudyGroupStudyGroupIdLinkListRouteRoute: typeof StudyGroupStudyGroupIdLinkListRouteRouteWithChildren
  StudyGroupStudyGroupIdStreamRouteRoute: typeof StudyGroupStudyGroupIdStreamRouteRouteWithChildren
  StudyGroupStudyGroupIdIndexRoute: typeof StudyGroupStudyGroupIdIndexRoute
  StudyGroupStudyGroupIdChannelChannelIdRouteRoute: typeof StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren
  StudyGroupStudyGroupIdPostPostIdRouteRoute: typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
}

const StudyGroupStudyGroupIdRouteRouteChildren: StudyGroupStudyGroupIdRouteRouteChildren =
  {
    StudyGroupStudyGroupIdEventsRouteRoute:
      StudyGroupStudyGroupIdEventsRouteRoute,
    StudyGroupStudyGroupIdFilesRouteRoute:
      StudyGroupStudyGroupIdFilesRouteRouteWithChildren,
    StudyGroupStudyGroupIdHomeRouteRoute:
      StudyGroupStudyGroupIdHomeRouteRouteWithChildren,
    StudyGroupStudyGroupIdInfoRouteRoute: StudyGroupStudyGroupIdInfoRouteRoute,
    StudyGroupStudyGroupIdLinkListRouteRoute:
      StudyGroupStudyGroupIdLinkListRouteRouteWithChildren,
    StudyGroupStudyGroupIdStreamRouteRoute:
      StudyGroupStudyGroupIdStreamRouteRouteWithChildren,
    StudyGroupStudyGroupIdIndexRoute: StudyGroupStudyGroupIdIndexRoute,
    StudyGroupStudyGroupIdChannelChannelIdRouteRoute:
      StudyGroupStudyGroupIdChannelChannelIdRouteRouteWithChildren,
    StudyGroupStudyGroupIdPostPostIdRouteRoute:
      StudyGroupStudyGroupIdPostPostIdRouteRoute,
  }

const StudyGroupStudyGroupIdRouteRouteWithChildren =
  StudyGroupStudyGroupIdRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdRouteRouteChildren,
  )

interface StudyGroupRouteRouteChildren {
  StudyGroupStudyGroupIdRouteRoute: typeof StudyGroupStudyGroupIdRouteRouteWithChildren
}

const StudyGroupRouteRouteChildren: StudyGroupRouteRouteChildren = {
  StudyGroupStudyGroupIdRouteRoute:
    StudyGroupStudyGroupIdRouteRouteWithChildren,
}

const StudyGroupRouteRouteWithChildren = StudyGroupRouteRoute._addFileChildren(
  StudyGroupRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRouteRoute: CalendarRouteRoute,
  CallbackRouteRoute: CallbackRouteRoute,
  ChatRoomRouteRoute: ChatRoomRouteRouteWithChildren,
  FavoritesRouteRoute: FavoritesRouteRoute,
  LogoutRouteRoute: LogoutRouteRoute,
  ProtoForAdminRouteRoute: ProtoForAdminRouteRoute,
  ProtoForUserRouteRoute: ProtoForUserRouteRoute,
  ProtoUiRouteRoute: ProtoUiRouteRoute,
  StudyGroupRouteRoute: StudyGroupRouteRouteWithChildren,
  TestLoginRouteRoute: TestLoginRouteRoute,
  NotFoundRoute: NotFoundRoute,
  AllStudyGroupsStudyGroupIdRouteRoute: AllStudyGroupsStudyGroupIdRouteRoute,
  EventSearchEventIdRouteRoute: EventSearchEventIdRouteRoute,
  NotificationEntryRouteRoute: NotificationEntryRouteRoute,
  PublicEventEventCodeRouteRoute: PublicEventEventCodeRouteRoute,
  UserProfileUserIdRouteRoute: UserProfileUserIdRouteRoute,
  SettingsInstantNotificationRoute: SettingsInstantNotificationRoute,
  SettingsPeriodicNotificationRoute: SettingsPeriodicNotificationRoute,
  AllStudyGroupsIndexRoute: AllStudyGroupsIndexRoute,
  EventSearchIndexRoute: EventSearchIndexRoute,
  EventSearchCodeEventCodeRouteRoute: EventSearchCodeEventCodeRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
